import { AdvisorLayerMode } from '../enums/advisorLayerMode'

export const isAdvisorLayerMode = (value: string | null): value is AdvisorLayerMode =>
  value === AdvisorLayerMode.Expert || value === AdvisorLayerMode.Client
